import axios from "axios";
const BASIC_API = process.env.REACT_APP_BASIC_API + "/EventDayManagement";

class EventDayService {
    create(data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}`,
            data, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    search(name, page) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.post(`${BASIC_API}/Search`, 
            {
                name,
                "pageRequestParameter": {
                    "isReturnAllDataAndNoPage": false,
                    "targetPage": page,
                    "showCount": 10
                }
            }, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    update(id, data) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.put(`${BASIC_API}/${id}`,
            data, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    getDetails(id) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.get(`${BASIC_API}/${id}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }

    delete(id) {
        let token;
        JSON.parse(localStorage.getItem("biodnd_admin_token"))
        ? token = JSON.parse(localStorage.getItem("biodnd_admin_token")).token
        : token = "";

        return axios.delete(`${BASIC_API}/${id}`, {
            headers: {Authorization: `Bearer ${token}`}
        });
    }
}

const NewEventDayService = new EventDayService();
export default NewEventDayService;